import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import BaseStatusChip from "@/components_v2/StatusChip/BaseStatusChip";
import { STATUS_CHIP_VARIANTS } from "@/components_v2/StatusChip/constants";
import { selectCurrentUser } from "@/redux/authentication/selectors";
import { Roles } from "@/shared/utils/constants";
import {
  MODERATION_STATES,
  UNDER_REVIEW_STATES,
} from "@/domains/moderation/constants";
import { ModerationStateChipProps } from "@/domains/moderation/types";

const ModerationStateChip = ({
  state,
  className,
}: ModerationStateChipProps) => {
  const { t } = useTranslation();
  const user = useSelector(selectCurrentUser);
  if (!state) {
    return null;
  }
  const audience = user?.role === Roles.ADMIN.value ? "admin" : "author";

  if (UNDER_REVIEW_STATES.includes(state)) {
    return (
      <BaseStatusChip
        label={t(`moderation.inPlace.${audience}.underReview`)}
        variant={STATUS_CHIP_VARIANTS.AMBER}
        className={className}
      />
    );
  }
  if (state === MODERATION_STATES.REJECTED) {
    return (
      <BaseStatusChip
        label={t(`moderation.inPlace.${audience}.removed`)}
        variant={STATUS_CHIP_VARIANTS.RED}
        className={className}
      />
    );
  }
  return null;
};

export default ModerationStateChip;
